import { HOUSES_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const housesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHouses: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: HOUSES_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Houses'],
    }),
    getHouseDetails: builder.query({
      query: (houseId) => ({
        url: `${HOUSES_URL}/${houseId}`,
      }),
      keepUnusedDataFor: 5,
    }),

    createHouse: builder.mutation({
  query: (data) => ({
    url: `${HOUSES_URL}`,
    method: 'POST',
    body: data,
  }),
  invalidatesTags: ['Houses'],
}),
    updateHouse: builder.mutation({
      query: (data) => ({
        url: `${HOUSES_URL}/${data.houseId}`,
        method: 'PUT',
        body: data, // Make sure this contains `images` as an array
      }),
      invalidatesTags: ['Houses'],
    }),
    uploadHouseImages: builder.mutation({ // Updated to handle multiple images
      query: (data) => ({
        url: `/api/upload`,
        method: 'POST',
        body: data, // Ensure this is a `FormData` object containing multiple images
      }),
    }),
    deleteHouse: builder.mutation({
      query: (houseId) => ({
        url: `${HOUSES_URL}/${houseId}`,
        method: 'DELETE',
      }),
      providesTags: ['House'],
    }),
    createReview: builder.mutation({
      query: (data) => ({
        url: `${HOUSES_URL}/${data.houseId}/reviews`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['House'],
    }),
    getTopHouses: builder.query({
      query: () => `${HOUSES_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGetHousesQuery,
  useGetHouseDetailsQuery,
  useCreateHouseMutation,
  useUpdateHouseMutation,
  useUploadHouseImagesMutation, // Updated for multiple images
  useDeleteHouseMutation,
  useCreateReviewMutation,
  useGetTopHousesQuery,
} = housesApiSlice;